import { useEffect, useState, useCallback } from "react";
import { getAssignmentOnboarding } from "./assignmentOnboardingApi.js";

/**
 * Fetches GET /api/backoffice/thailand-jobs/assignments/{assignmentId}/onboarding
 * for exactly one assignment - there is no list to page through here (see
 * assignmentOnboardingApi.js's own doc comment: P110 has no cross-
 * assignment onboarding list endpoint). Refetches whenever assignmentId
 * changes, and `refetch` lets the page force a reload after a successful
 * device-binding/SIM-binding/mobile-handover-ready submit without
 * unmounting the page.
 */
export function useAssignmentOnboarding(assignmentId) {
  const [state, setState] = useState({ status: "loading", data: null, error: null });
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    if (!assignmentId) {
      setState({ status: "idle", data: null, error: null });
      return undefined;
    }

    let cancelled = false;
    setState((previous) => ({ status: "loading", data: previous.data, error: null }));

    getAssignmentOnboarding(assignmentId)
      .then((data) => {
        if (!cancelled) {
          setState({ status: "ready", data, error: null });
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setState({ status: "error", data: null, error });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [assignmentId, reloadToken]);

  const refetch = useCallback(() => setReloadToken((token) => token + 1), []);

  return { ...state, refetch };
}
